module.exports = __webpack_public_path__ + "img/activity-sheet_thumbnail_raccoon.5638718b.jpg";